// TODO: maybe put these in JAHIA somehow, map errorCodes to messages
// these are errorCode keys that return when an API request errors
const ALERT_MODAL_TYPES: {[key: string]: any} = {
  NO_TSW_AVAILABILITY: 'no_tsw_availability',
  NO_AVAILABILITY_FILTERED_MONTHLY: 'no_availability_filtered_monthly',
  MAX_HOLD_INVENTORY_LIMIT_REACHED: 'max_hold_inventory_limit_reached',
  EXPRESSION: 'no_tsw_availability',
  FATAL: 'no_tsw_availability'
}

const ALERT_MODALS: {[key: string]: any} = {
  [ALERT_MODAL_TYPES.NO_TSW_AVAILABILITY]: {
    header: "static.content.availability-has-changed",
    message: "static.content.room-no-longer-available",
  },
  [ALERT_MODAL_TYPES.MAX_HOLD_INVENTORY_LIMIT_REACHED]: {
    header: "static.content.maximum-holds-placed",
    message: "static.content.maximum-holds-placed-msg",
  },
  [ALERT_MODAL_TYPES.NO_AVAILABILITY_FILTERED_MONTHLY]: {
    header: "static.content.availability-has-changed",
    message: "static.content.monthly-availability-changed",
  }
};


export {
  ALERT_MODAL_TYPES,
  ALERT_MODALS,
};

//rokt
export const ACCOUNT_ID='2895615527472085184';